type iconProps = {
  fill?: string
  secondaryfill?: string
  strokewidth?: number
  width?: string
  height?: string
  className?: string
  title?: string
}

function ArrowsExpandDiagonal(props: iconProps) {
  const title = props.title || 'arrows expand diagonal 2'

  return (
    <svg
      height='48'
      width='48'
      viewBox='0 0 48 48'
      xmlns='http://www.w3.org/2000/svg'
      className={props.className}
    >
      <title>{title}</title>
      <g fill='#0e1647'>
        <path
          d='M28 25.8787L43.5606 41.4394L41.4393 43.5607L25.8787 28L28 25.8787Z'
          fill='#0e1647'
          fillRule='evenodd'
        />
        <path
          d='M7.12143 5L5.00012 7.12132L20.0001 22.1213L22.1214 20L7.12143 5Z'
          fill='#0e1647'
          fillRule='evenodd'
        />
        <path d='M7 24V7H24V4H4V24H7Z' fill='#0e1647' fillRule='evenodd' />
        <path d='M41 24V41H24V44H44V24H41Z' fill='#0e1647' fillRule='evenodd' />
      </g>
    </svg>
  )
}

export default ArrowsExpandDiagonal
